import { useCallback, useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';

interface UseDashboardResult {
  data: any;
  isLoading: boolean;
  error: any;
  fetchData: () => void;
  handleChangeParams: (filter: any) => void;
}

export const useDashboard = (
  api,
  options = { defaultParams: {} }
): UseDashboardResult => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { defaultParams } = options;

  const [params, setParams] = useState<any>({
    ...defaultParams
  });

  const fetchData = useCallback(() => {
    setIsLoading(true);
    api
      .findAll(params)
      .then((response) => {
        setData(response);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [params]);

  const handleChangeParams = (filter: any) => {
    setParams((prevState) => ({
      ...prevState,
      ...filter
    }));
  };

  useDeepCompareEffect(() => {
    fetchData();
  }, [params]);

  return {
    data,
    isLoading,
    error,
    fetchData,
    handleChangeParams
  };
};
